import styled from 'styled-components';

export const PartnerWrapper = styled.div`
  height: 37px;
  left: 0;
  position: absolute;
  top: 0;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    height: 40px;
  }
`;
export const PartnerInner = styled.div`
  background-color: ${props => props.theme.carvana.white.primary};
  border-radius: 0 15px 0px 0px;
  display: inline-block;
  height: 100%;
  max-width: 195px;
  position: relative;
  z-index: 2;

  &:before {
    height: 37px;
    width: 32px;
    border-radius: 0px 6px 0px 0px;
    background-color: ${props => props.theme.carvana.white.primary};
    content: '';
    position: absolute;
    right: -10px;
    top: 0px;
    -webkit-transform: skewX(40deg);
    transform: skewX(40deg);
    z-index: -1;

    @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
      border-radius: 0px 10px 0px 0px;
      height: 40px;
      right: -19px;
      width: 40px;
    }
  }

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    max-width: 334px;
  }
`;
export const PartnerInfo = styled.div`
  align-items: flex-end;
  display: inline-flex;
  height: 100%;
  padding: 0 16px;
  width: 100%;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    padding: 0 33px 0;
  }
`;
export const PartnerLogoWrapper = styled.div`
  height: 100%;
  padding-top: 4px;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    padding-top: 8px;
  }
`;
export const PartnerLogo = styled.img`
  height: 100%;
  width: auto;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    height: 100%;
    max-height: 29px;
    width: 100%;
  }

  @media all and (min-width: ${props => props.theme.breakpoints.values.sm}px) and (-ms-high-contrast: none),
  (-ms-high-contrast: active) {
    max-height: 40px;
  }
`;
export const PartnerCopyWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  margin-right: 10px;
  margin-left: 5px;
  margin-bottom: -3px;
`;
export const VerticalLine = styled.div`
  border-left: 1px solid ${props => props.theme.carvana.gray.dark};
  height: 16px;
  margin: 1px 6px 0 0px;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    margin: 1px 6px 0 19px;
  }
`;
export const PartnerCopy = styled.div`
  color: ${props => props.theme.carvana.gray.dark};
  font-size: 8px;
  font-weight: 400;
  height: 19px;
  letter-spacing: 0.16px;
  line-height: 10px;
  text-transform: uppercase;
  width: 54px;
`;
